/**
 * When `NEXT_PUBLIC_STRIPE_SUBSCRIPTION_REQUIRED` is `false` (or `0`), shelter admins
 * are not redirected to checkout and feature gates are relaxed for local/dev work.
 * Defaults to required (`true`) when unset.
 */
export function isStripeSubscriptionRequired(): boolean {
  const raw = process.env.NEXT_PUBLIC_STRIPE_SUBSCRIPTION_REQUIRED?.trim()
    .toLowerCase();
  if (!raw) return true;
  return raw !== 'false' && raw !== '0' && raw !== 'no';
}
